export const POST_NEW_TRADE_OFFER = 'POST_NEW_TRADE_OFFER';
export const POST_NEW_TRADE_OFFER_DONE = 'POST_NEW_TRADE_OFFER_DONE';

export const FETCH_POSTED_OFFERS = 'FETCH_POSTED_OFFERS';
export const FETCH_POSTED_OFFERS_DONE = 'FETCH_POSTED_OFFERS_DONE';



// WEBPACK FOOTER //
// ./app/constants/postedOffersTypes.js